import SpoilerEditorWrapper from './Components/Wrappers/SpoilerEditorWrapper.js';
import { DEFAULTS } from './defaults.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { SPOILER_TYPE } from './types.js';
export { default as BlockSpoilerComponent } from './Components/BlockSpoilerComponent.js';
import { getTextButtons } from './getTextButtons.js';
import 'prop-types';
import 'react';
import '@tiptap/pm/state';
import 'ricos-schema';
import 'ricos-schema/dist/statics/color.defaults.json';
import 'wix-rich-content-plugin-commons';
import 'classnames';
import 'lodash';
import './spoiler-ad1e15b8.js';
import './Components/SpoilerContainer.js';
import 'wix-rich-content-common/libs/Tooltip';
import './icons/SpoilerContainerIcon.js';
import './Components/RevealButton.js';
import './Components/EditableInputWrapper.js';
import './Components/SpoilerDescriptionInput.js';
import 'ricos-types';
import 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import './icons/SpoilerTextButtonIcon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const pluginSpoiler = (config) => {
  const pluginConfig = __spreadValues(__spreadProps(__spreadValues({}, DEFAULTS.config), { SpoilerEditorWrapper }), config);
  return {
    config: pluginConfig,
    type: SPOILER_TYPE,
    tiptapExtensions,
    textButtons: getTextButtons()
  };
};

export { SpoilerEditorWrapper, pluginSpoiler };
//# sourceMappingURL=editor.js.map
